import { render, staticRenderFns } from "./text_widget.vue?vue&type=template&id=83a4ab96&scoped=true&lang=pug"
import script from "./text_widget.vue?vue&type=script&lang=js"
export * from "./text_widget.vue?vue&type=script&lang=js"
import style0 from "./text_widget.vue?vue&type=style&index=0&id=83a4ab96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a4ab96",
  null
  
)

export default component.exports